<template>
  <div class="webdatalist">
    <f7-list media-list id="draft-list">
      <div class="showSmallScreenOnly">
      <ul>
        <li v-for="draft in drafts" class="swipeout" @swipeout:deleted="deleteDraft(draft.idDraft)">
          <div class="item-content swipeout-content draftTaphold boxRequest" :data-item="draft.idDraft" :data-complete="draft.isComplete" @click="createPayments(draft)">
            <div class="item-media">
              <i class="icon list-icon icon-edit"></i>
            </div>
            <div class="item-inner">
              <div class="item-title"><span style="font-size: 90%; color: orange;"><i  v-if="draft.versionNumber > 1" class="fa fa-exclamation-triangle"></i></span> {{ draft.draftName }}</div>
              <!-- Si le draft complet et pas encore validé, ou partiellement mais l'utilisateur actuel peut, alors on affiche waiting for validation-->
              <div class="item-subtitle" v-if="draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)">
                <i class="fa fa-clock-o streammindBlueFont iconStatus"/> {{getLabelStatus(draft)}}
              </div>
              <!-- Si le draft est complet mais l'utilisateur ne peut pas valider, alors waiting for manager validation -->
              <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '2'">
                <span style="color: orange;"><i class="fa fa-clock-o iconStatus"/></span> {{getLabelStatus(draft)}}
              </div>
              <!-- Ready to send -->
              <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '1'">
                <i class="fa fa-check greenFont iconStatus"/> {{getLabelStatus(draft)}}
              </div>
              <!-- Needs to be completed -->
              <div class="item-subtitl" v-else-if="draft.isComplete === '0' || draft.isComplete === ''">
                <i class="fa fa-pencil redFont iconStatus"/> {{getLabelStatus(draft)}}
              </div>
            </div>
            <div v-if="(draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator">
              <label style="margin-right: 30px; margin-top: 10px; font-size: 25px;"><i class="fa fa-exclamation-circle streammindBlueFont"></i></label>
            </div>
          </div>
          <div class="swipeout-actions-right">
            <a href="#" class="swipeout-delete"
            data-confirm="You won't be able to recover this draft from MoneyRoad"
            data-confirm-title="Remove?"
            data-close-on-cancel="true">
              Delete
            </a>
          </div>
        </li>
      </ul>
      </div>
      <div class="showLargeScreenOnly">
        <li :key="draft.idDraft" v-for="draft in drafts">
          <div class=" item-content draftTaphold boxRequest"
          :data-item="draft.idDraft"
          :data-complete="draft.isComplete"
          @click="createPayments(draft)"
          >
            <div class="item-media">
              <!-- <f7-icon f7="compose_fill" class="streammindBlueFont"></f7-icon> -->
              <i class="icon list-icon icon-edit"></i>
            </div>
            <div class="item-inner col-4">
              <div class="item-title-row">
                <table>
                  <tr>
                    <td class="requestTitle">
                        {{draft.draftName}}
                    </td>
                  </tr>
                  <tr>
                    <td class="item-subtitle-row">
                      <span style="font-size: 90%; color: orange;"><i  v-if="draft.versionNumber > 1" class="fa fa-exclamation-triangle"></i></span><label class="versionSubTitle">Version {{draft.versionNumber}}</label>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-6">
              <table>
                <tr>
                  <td class="">
                    <!-- Ready to send -->
                    <div class="item-subtitle" v-if="draft.isComplete === '1' && draft.isValidated === '1'">
                      <i class="fa fa-check iconStatus greenFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Needs to be completed -->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '0' || draft.isComplete === ''">
                      <i class="fa fa-pencil iconStatus redFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Si le draft complet et pas encore validé, ou partiellement mais l'utilisateur actuel peut, alors on affiche waiting for validation-->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)">
                      <i class="fa fa-clock-o iconStatus streammindBlueFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Si le draft est complet mais l'utilisateur ne peut pas valider, alors waiting for manager validation -->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '2'">
                      <span style="color: orange;"><i class="fa fa-clock-o iconStatus"/></span> {{getLabelStatus(draft)}}
                    </div>
                  </td>
                  <td class="statusLabel2" v-if="(draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator">
                    <label><i class="fa fa-exclamation-circle iconStatus streammindBlueFont"></i><span style="font-size: 15px;"> Validation required</span></label>
                  </td>
                </tr>
              </table>
            </div>
            <div class="item-media col-1">
              <button class="button-swipe-out button-big button-bank-account boxRequest" onclick="event.stopPropagation()" @click="deleteDraftWebIHM(draft.idDraft)">
                <i class="fa fa-times-circle button-delete" ></i>
              </button>
            </div>
          </div>
        </li>
      </div>

    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
// import dpCreateTemplate from '../../requests/creationPages/DPCreateTemplate.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'DraftList',
  props: ['drafts'],
  data: () => {
    return {
      isValidator: false
    }
  },
  created () {
  },
  beforeMount () {
  },
  updated () {
  },
  computed: {
  },
  methods: {
    createPayments (draft) {
      let that = this
      that.$engine.settings.set({preChargedDraft: draft})
      loadPage(that, {url: '/directPayments/draft/edit/'})
    },
    getLabelStatus (draft) {
      if (draft.isComplete === '1') {
        if (draft.isValidated === '1') {
          return 'Ready to send'
        } else if (draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)) {
          return 'Waiting for validation'
        } else {
          return 'Waiting for the supervisor validation'
        }
      } else {
        return 'Need to be completed'
      }
    },
    deleteDraft (idDraft) {
      let that = this
      that.$engine.dpDrafts
      .del(idDraft)
      .then(() => {
        that.$f7.alert('', 'Draft Removed')
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    },

    deleteDraftWebIHM (idDraft) {
      let that = this
      this.$f7.modal({
        title: 'Delete ?',
        text: 'You won\'t be able to recover this draft from MoneyRoad',
        buttons: [
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: 'Yes',
            onClick: function () {
              var idDraftInList = -1
              for (var i = 0; i < that.drafts.length; i++) {
                if (that.drafts[i].idDraft === idDraft) {
                  idDraftInList = i
                  break
                }
              }
              that.drafts.splice(idDraftInList, 1)
              that.deleteDraft(idDraft)
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
li {
  background-color: white;
  list-style: none;
}

.statusLabel2 {
  padding-top: 10px;
padding-left: 150px
}

.iconStatus {
  font-size: 17px;
}

.versionSubTitle {
  margin-left: 5px;
  color: grey;
  font-size: 70%;
}

</style>



// WEBPACK FOOTER //
// DPDraftList.vue?0d909510